import React from "react";
import { Navbar, Container, NavbarBrand } from 'reactstrap';
import {Logotipo} from "constants/Logotipo";

class Navigation extends React.Component{
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);        
        this.state = {
            isOpen: false,
            logotipo: ""
        };        
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen            
        });
    }
    
    render(){
        return(
            <Navbar expand="sm" className="menu" color="operadora">
                <Container>
                <NavbarBrand></NavbarBrand>
                </Container>
            </Navbar>
        );
    }
}
export default Navigation;